import { Component, Input } from '@angular/core';

@Component({
  selector: 'content-header-image',
  templateUrl: './header-image.component.html',
  styleUrls: ['./header-image.component.scss'],
})
export class ContentHeaderImageComponent {
  @Input() content?: any;

  loaded?: boolean;
  ideaDisabled = false;
  productionDisabled = false;
  constructor() {}
}
